<template>
  <div class="sharkfoto">
    <FotoHeader />
    <div class="warp">
      <main>
        <NuxtPage keep-alive :keep-alive-props="{ include: includeArr }" />
      </main>
    </div>
    <FotoFooter />
    <CookieBanner />
    <!-- Creati.ai Ads -->
    <template v-if="showAds">
      <CreateaiAds></CreateaiAds>
    </template>
  </div>
</template>
<script setup>
import FotoHeader from "@/components/FotoHeader.vue";
import FotoFooter from "@/components/FotoFooter.vue";
import CookieBanner from "@/components/common/CookieBanner";
import CreateaiAds from "@/components/adsCreatiAi/ads.vue";
import { useHead, ref, onMounted } from "#imports";
import defaultCssUrl from "~/assets/styles/index.scss?url";

useHead({
  link: [
    {
      rel: "stylesheet",
      href: defaultCssUrl,
      crossorigin: "anonymous",
      crossorigin: "anonymous",
      key: "layout-style",
    },
    {
      rel: "preload",
      href: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6439841372484008",
      as: "script",
      crossorigin: "anonymous",
    },
    {
      rel: "preload",
      href: "https://www.googletagservices.com/tag/js/gpt.js",
      as: "script",
    },
  ],
});

// 响应式数据
const timer = ref(false);
const includeArr = ref(["incredible-quality"]);
const showAds = ref(false);

// 组件挂载时处理广告逻辑
onMounted(() => {
  if (!localStorage.getItem("creati_ai_ads")) {
    // showAds.value = true;
    localStorage.setItem("creati_ai_ads", "true");
  }
});
</script>

<style lang="scss" scoped>
.warp {
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
main {
  width: 100%;
  max-width: 1280px;
}
main > div {
  padding-bottom: 20px;
  margin-bottom: 35px;
}
</style>
